import React from "react";

const AccessDenied = (props) => {
    return (
        <>
            <p className="text-danger">You do not have access to this application.</p>
            <p className="text-danger">Please logout first and then login with a different user account.</p>
        </>
    );
}
export default AccessDenied;